export function pageGroups(items) { return Array.from({length:Math.ceil(items.length/8)},(_,i)=>items.slice(i*8,i*8+8)); }
class McmClassPrint extends HTMLElement {
 connectedCallback() {
  this.onBefore=()=>{if(this.readyURL!==window.location.href)this.build(this.loaded());document.documentElement.classList.add('mcm-printing-classes');};
  this.onAfter=()=>document.documentElement.classList.remove('mcm-printing-classes');

  window.addEventListener('beforeprint',this.onBefore);window.addEventListener('afterprint',this.onAfter);
 }
 loaded(root=this.closest('results-list')) { return [...root.querySelectorAll('[data-mcm-print-image]')].map(el=>({id:el.dataset.mcmPrintId,src:el.dataset.mcmPrintImage,title:el.dataset.mcmPrintTitle})).filter(item=>item.src); }
 build(items) {
  document.getElementById('mcm-classes-print-root')?.remove();
  const root=document.createElement('div');root.id='mcm-classes-print-root';
  for(const group of pageGroups(items)) {
   const page=document.createElement('section');page.className='mcm-class-print-page';
   const header=document.createElement('div');header.className='mcm-class-print-header';
   const logo=document.createElement('img');logo.src=this.dataset.header;logo.alt='Manchester Craft Market classes and workshops';header.append(logo);page.append(header);
   const grid=document.createElement('div');grid.className='mcm-class-print-grid';
   for(const item of group){const image=document.createElement('img');image.src=item.src;image.alt=item.title;image.loading='eager';grid.append(image);}
   page.append(grid);root.append(page);
  }
  document.body.append(root);return root;
 }
 disconnectedCallback(){window.removeEventListener('beforeprint',this.onBefore);window.removeEventListener('afterprint',this.onAfter);this.onAfter();document.getElementById('mcm-classes-print-root')?.remove();}
}
if(!customElements.get('mcm-class-print'))customElements.define('mcm-class-print',McmClassPrint);
